import { landingProfessions } from "@data/mocks";
import { appMounted, routePathNameChanged } from "@features/app/model";
import { landingScreenPresented } from "@features/shared/events";
import { ModelContract, ModuleDescription } from "@features/shared/module-description";
import { createEffect, createEvent, createStore, sample } from "effector";

const loadProfessionsData = createEvent();

const $professionsData = createStore<string[]>([]).on(loadProfessionsData, () => landingProfessions);

const trackLandingScreenPresentedFx = createEffect(() => {
    landingScreenPresented();
});

const contract = new ModelContract({ $professionsData }, { loadProfessionsData }, {}, {});

export type ILandingContract = typeof contract;

const isLandingRoute = (pathname: string): boolean => {
    return pathname === "/" || pathname === "/luck";
};

export class LandingModule extends ModuleDescription<ILandingContract> {
    getDefaultContract() {
        return contract;
    }

    run(): void {
        sample({
            clock: [appMounted, routePathNameChanged],
            filter: () => {
                if (typeof window === "undefined") return false;
                return isLandingRoute(window.location.pathname);
            },
            target: [loadProfessionsData, trackLandingScreenPresentedFx]
        });
    }
}
